/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * <p>
 * Copyright © 2019 Pearson Education, Inc.
 * All Rights Reserved.
 * <p>
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 *
 * This is the data class for holding partner attributes.
 *
 * @author urahish
 * 02/09/2022
 *
 */

import React from 'react';
import '../Partner/partner.css';
import '../ViewAudit/viewEdit.css'
import Table from "../../components/generic/table/table";

import tableConfigs from "../../components/generic/table/tableConfigs";
import EventEmitter from "../../eventEmmiters/EventEmitter";
import Drawer from 'react-modern-drawer'
import 'react-modern-drawer/dist/index.css'
import ViewErrorFilterForm from "../../components/generic/forms/HOC/view-error/viewErrorFilterForm";

// get table configurations
const table = tableConfigs.viewError;

class ViewError extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isDisplayDrawer: false
        };

        EventEmitter.emit('setPageHeaderData', {
            page: 'view-error',
            pageName: "View Errors",
            pageLink: process.env.REACT_APP_BASE_URL + "/#/home/view-error",
            optionalIcons: ['manageColumnsIcon']
        });

        EventEmitter.on('openNav', this.openNav);
    }

    componentWillUnmount = () => {
        EventEmitter.off('openNav', this.openNav);
    };

    openNav = () => {
        this.setState({isDisplayDrawer: !this.state.isDisplayDrawer});
    }

    render() {
        return(<div>
                <div className="view-edit-table-container">
                    <Table tableConfig={table} routerProps={this.props} pathname={'view-error'}/>
                    {!this.state.isDisplayDrawer &&
                        <div className="main-btn-container">
                            <div className="buttons" tooltip="Filter records"
                                 onClick={() => this.openNav()}>
                                <i className="fa fa-filter fa-lg icon-primary"/>
                            </div>
                        </div>
                    }
                </div>

                <Drawer open={this.state.isDisplayDrawer}
                        onClose={() => this.openNav()}
                        className={'view-edit-drawer'}
                        direction='right'
                        style={{maxHeight: '100vh'}}
                >
                    <ViewErrorFilterForm />
                </Drawer>
            </div>
        )
    }
}

export default ViewError;
